class BirdTemplate extends HTMLElement {
  constructor() {
    super();
    this.currentMediaIndex = 0;
    this.mediaItems = [];
    this.isFormExpanded = false;
  }

  connectedCallback() {
    this.initializeElements();
    this.setupEventListeners();
    this.initializeMediaItems();
  }

  initializeElements() {
    this.mainMedia = this.querySelector('[data-main-media]');
    this.thumbnails = this.querySelectorAll('.gc-bird-thumbnail');
    this.tabButtons = this.querySelectorAll('.gc-bird-tab-button');
    this.tabContents = this.querySelectorAll('.gc-bird-tab-content');
    this.lightbox = this.querySelector('[data-lightbox]');
    this.lightboxMedia = this.querySelector('[data-lightbox-media]');
    this.lightboxClose = this.querySelector('[data-lightbox-close]');
    this.contactToggle = this.querySelector('.gc-bird-contact-toggle');
    this.contactForm = this.querySelector('.gc-bird-contact-form');
    this.toggleIcon = this.querySelector('.gc-bird-contact-toggle-icon');
  }

  initializeMediaItems() {
    // Get media items from thumbnails data attributes
    this.thumbnails.forEach(thumbnail => {
      const index = parseInt(thumbnail.dataset.mediaIndex);
      const mainSrc = thumbnail.dataset.mainSrc;
      const lightboxSrc = thumbnail.dataset.lightboxSrc;
      const alt = thumbnail.dataset.alt;
      
      if (mainSrc && lightboxSrc) {
        this.mediaItems[index] = {
          type: 'image',
          mainSrc: mainSrc,
          lightboxSrc: lightboxSrc,
          alt: alt || ''
        };
      }
    });
    
    // Also get the main media if no thumbnails
    if (this.mediaItems.length === 0 && this.mainMedia) {
      const mainImg = this.mainMedia.querySelector('img');
      if (mainImg) {
        this.mediaItems[0] = {
          type: 'image',
          mainSrc: mainImg.src,
          lightboxSrc: mainImg.src.replace('_800x.', '_1200x.'),
          alt: mainImg.alt || ''
        };
      }
    }
  }

  setupEventListeners() {
    this.thumbnails.forEach((thumbnail, index) => {
      thumbnail.addEventListener('click', () => {
        this.switchMedia(index);
      });
    });

    this.tabButtons.forEach(button => {
      button.addEventListener('click', () => {
        const tabName = button.dataset.tab;
        this.switchTab(tabName);
      });
    });

    if (this.mainMedia) {
      this.mainMedia.addEventListener('click', () => {
        this.openLightbox();
      });
    }

    if (this.lightboxClose) {
      this.lightboxClose.addEventListener('click', () => {
        this.closeLightbox();
      });
    }

    if (this.lightbox) {
      this.lightbox.addEventListener('click', (e) => {
        if (e.target === this.lightbox) {
          this.closeLightbox();
        }
      });
    }

    if (this.contactToggle) {
      this.contactToggle.addEventListener('click', () => {
        this.toggleContactForm();
      });
    }

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.closeLightbox();
      }
    });
  }

  switchMedia(index) {
    this.currentMediaIndex = index;
    
    this.thumbnails.forEach((thumb, i) => {
      thumb.classList.toggle('active', i === index);
    });

    if (this.mediaItems[index] && this.mainMedia) {
      const media = this.mediaItems[index];
      this.mainMedia.innerHTML = `<img src="${media.mainSrc}" alt="${media.alt}" loading="lazy">`;
    }
  }

  switchTab(tabName) {
    this.tabButtons.forEach(button => {
      button.classList.toggle('active', button.dataset.tab === tabName);
    });

    this.tabContents.forEach(content => {
      content.classList.toggle('active', content.dataset.tabContent === tabName);
    });
  }

  toggleContactForm() {
    this.isFormExpanded = !this.isFormExpanded;
    
    if (this.contactForm) {
      this.contactForm.classList.toggle('expanded', this.isFormExpanded);
    }
    
    if (this.toggleIcon) {
      this.toggleIcon.classList.toggle('expanded', this.isFormExpanded);
    }
  }

  openLightbox() {
    if (this.mediaItems[this.currentMediaIndex] && this.lightbox && this.lightboxMedia) {
      const media = this.mediaItems[this.currentMediaIndex];
      this.lightboxMedia.innerHTML = `<img src="${media.lightboxSrc}" alt="${media.alt}" class="gc-bird-lightbox-media">`;
      this.lightbox.style.display = 'flex';
    }
  }

  closeLightbox() {
    if (this.lightbox) {
      this.lightbox.style.display = 'none';
    }
  }
}

customElements.define('bird-template', BirdTemplate);